"use strict";
import { __require as u } from "./index.es402.js";
var e, i;
function o() {
  if (i) return e;
  i = 1;
  var r = /* @__PURE__ */ u();
  if (r)
    try {
      r([], "length");
    } catch {
      r = null;
    }
  return e = r, e;
}
export {
  o as __require
};
//# sourceMappingURL=index.es317.js.map
